import { useQuery } from '@tanstack/react-query';
import { AdminDailyScheduleTemplate } from '#types/schedule';
import { fetcher } from '../libs';
import queryKeys from '../queryKeys';

interface Params {
  /** 조회할 날짜 (YYYY-MM-DD) */
  startAt?: string;
  /** 쿼리 활성화 여부 */
  enabled?: boolean;
}

/**
 * admin 헬스장 관리자 - 소속 트레이너 일정 불러오기(일간)
 *
 * @link https://api-dev.fibud.kr/api#/헬스장%20관리자/GymAdminsController_findAllCoachScheduleOfGymPerWeek
 * @returns
 */
export default function useGymAdminsScheduleDayQuery({
  startAt,
  enabled
}: Params) {
  return useQuery(
    [queryKeys.GYM_ADMINS, 'day', startAt],
    () =>
      fetcher<AdminDailyScheduleTemplate[]>(
        `/gym-admins/coach-schedule/day/v2`,
        {
          params: {
            startAt
          }
        }
      ),
    {
      enabled: !!startAt && enabled
    }
  );
}
